/**
 * Counts occurrences of each element in an array
 */
export const countBy = <T, K extends string | number | symbol>(
  array: T[],
  keyFn: (item: T) => K
): Record<K, number> => {
  return array.reduce(
    (counts, item) => {
      const key = keyFn(item)
      counts[key] = (counts[key] || 0) + 1
      return counts
    },
    {} as Record<K, number>
  )
}
